// extracted by css-extract-rspack-plugin
export default {"container":"src-app-components-forms-Button-Button-module__container-Wq81za","mini":"src-app-components-forms-Button-Button-module__mini-lweydg","full":"src-app-components-forms-Button-Button-module__full-TnlkA5","badge":"src-app-components-forms-Button-Button-module__badge-eDD5QT","red":"src-app-components-forms-Button-Button-module__red-JuZDcw","onlyIcon":"src-app-components-forms-Button-Button-module__onlyIcon-yMFN_x","disabled":"src-app-components-forms-Button-Button-module__disabled-wdF4mX","material":"src-app-components-forms-Button-Button-module__material-d171XU"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"src-app-components-forms-Button-Button-module__container-Wq81za\",\"mini\":\"src-app-components-forms-Button-Button-module__mini-lweydg\",\"full\":\"src-app-components-forms-Button-Button-module__full-TnlkA5\",\"badge\":\"src-app-components-forms-Button-Button-module__badge-eDD5QT\",\"red\":\"src-app-components-forms-Button-Button-module__red-JuZDcw\",\"onlyIcon\":\"src-app-components-forms-Button-Button-module__onlyIcon-yMFN_x\",\"disabled\":\"src-app-components-forms-Button-Button-module__disabled-wdF4mX\",\"material\":\"src-app-components-forms-Button-Button-module__material-d171XU\"}";
        // 1789362522835
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  